import React from "react";
import {
  Box,
  Image,
  Grid,
  GridItem,
  Flex,
  Text,
  Heading,
  Center,
  Stack,
  Divider,
  Link,
} from "@chakra-ui/react";
import { useTheme } from "@chakra-ui/react";
import exp1 from "../../assets/images/exp2.jpg"; // Ensure the correct image path

const Experience = () => {
  const theme = useTheme();

  const experience = [
    {
      name: "KALSYM Sdn. Bhd.",
      info: "An ICT Solution Provider focusing on Software Development, White Label Platform, Telecom Solutions, & Talent on Demand.",
      role: "Backend Developer",
      position: "Internship, Part-time",
      time: "1 year 4 mos",
      details: "Worked on various backend projects using NestJS, FastAPI, MongoDB, and MySQL. Key projects included an analytics system, fraud detection system, recommendation engine, and global customer profiling platform.",
      link: "https://www.kalsym.com/",
      image: exp1,
    },
  ];

  return (
    <Box p={{ base: "2", md: "4" }}>
      <Heading
        fontSize={{ base: "28px", md: "32px", lg: "36px" }}
        fontWeight={600}
        fontFamily={theme.font.secondary}
        color={theme.colors.primary}
        py={"0.3em"}
        textAlign="center"
      >
        Experience
      </Heading>

      <Grid templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)" }} gap={6} py={6}>
        {experience.map((exp, index) => (
          <GridItem colSpan={1} key={index}>
            <Center py={6}>
              <Box
                role={"group"}
                p={6}
                maxW={{ base: "100%", md: "350px", lg: "450px" }}
                w={"full"}
                bg="white"
                boxShadow={"2xl"}
                rounded={"lg"}
                pos={"relative"}
                zIndex={1}
              >
                <Box
                  rounded={"lg"}
                  mt={-12}
                  pos={"relative"}
                  height={"230px"}
                  _after={{
                    transition: "all .3s ease",
                    content: '""',
                    w: "full",
                    h: "full",
                    pos: "absolute",
                    top: 5,
                    left: 0,
                    backgroundImage: `url(${exp.image})`,
                    filter: "blur(15px)",
                    zIndex: -1,
                  }}
                  _groupHover={{
                    _after: {
                      filter: "blur(20px)",
                    },
                  }}
                  boxShadow={`0 10px 20px ${theme.colors.primary}`} // Add the shadow here
                >
                  <Image
                    rounded={"lg"}
                    height={{ base: "200px", md: "250px", lg: "250px" }}
                    width={{ base: "100%", md: "350px", lg: "450px" }}
                    objectFit={"cover"}
                    src={exp.image}
                    alt={exp.name}
                  />
                </Box>

                <Stack pt={10} align={"center"}>
                  <Heading fontSize={{ base: "xl", md: "2xl" }} fontFamily={"body"} fontWeight={500}>
                    {exp.name}
                  </Heading>
                  <Text color={"gray.500"} fontSize={{ base: "sm", md: "md" }}>
                    {exp.role} - {exp.position}
                  </Text>
                  <Text color={"gray.500"} fontSize={{ base: "sm", md: "md" }}>
                    {exp.time}
                  </Text>
                  <Divider w={"25%"} borderWidth="1px" borderColor={theme.colors.primary} />
                  <Text color={"gray.600"} px={3} textAlign="center" fontSize={{ base: "sm", md: "md" }}>
                    {exp.details}
                  </Text>
                  <Link href={exp.link} isExternal color={theme.colors.secondary} fontWeight={600}>
                    Visit Website
                  </Link>
                </Stack>
              </Box>
            </Center>
          </GridItem>
        ))}

        <GridItem colSpan={1}>
          <Flex direction="column" justifyContent="center">
            <Heading
              fontSize={{ base: "24px", md: "28px", lg: "32px" }}
              fontWeight={600}
              fontFamily={theme.font.secondary}
              color={theme.colors.primary}
              py={"0.5em"}
            >
              Some Projects I worked with.
            </Heading>
            {["Analytic System (NestJS & MongoDB)", "Fraud Detection System (FastAPI & MySQL)", "Recommendation Engine (NestJS & FastAPI)", "Global Customer Profiling (NestJS & MongoDB)"].map((project, idx) => (
              <Box
                key={idx}
                bg={theme.colors.secondary}
                p={{ base: "2", md: "4" }}
                color={theme.colors.secondText}
                borderRadius="md"
                _hover={{ bg: theme.colors.thirdly }}
                mb={4}
              >
                <Text fontWeight={600}>{project}</Text>
                <Text fontSize={{ base: "sm", md: "md" }}>
                  {idx === 0 && "Developed a custom analytics platform for business insights using NestJS and MongoDB."}
                  {idx === 1 && "Designed a machine learning-based fraud detection system, optimizing for accuracy and performance."}
                  {idx === 2 && "Implemented a recommendation engine to provide personalized content for customers."}
                  {idx === 3 && "Built a global customer profiling system that integrates various data sources to provide tailored services."}
                </Text>
              </Box>
            ))}
          </Flex>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default Experience;
